import React from 'react';
import clsx from 'clsx';
import {
  Element,
  FontType,
  Color,
  Typography
} from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';

const BackWithBottomLogo = ({
  logo,
  logoAlt,
  header,
  flagText,
  disclaimer,
  tag
}) => {
  return (
    <Element className={clsx(styles.contentContainer, styles.back)}>
      <Typography
        Component="h3"
        $size="15px"
        $lineHeight="120%"
        $family={FontType.HelveticaBold}
        theme={{ color: Color.DeepBlue, marginBottom: 10 }}
        className={styles.subHeader}
      >
        {header}
        {tag && (
          <Typography
            Component="span"
            className={styles.tag}
            $size="10px"
            $lineHeight="120%"
            $family={FontType.BentonBold}
            theme={{ color: Color.White }}
          >
            {tag}
          </Typography>
        )}
      </Typography>
      <Element>
        <Typography
          $family={FontType.HelveticaRegular}
          theme={{ color: Color.Gray06 }}
          className={styles.backText}
        >
          {flagText}
        </Typography>
        {disclaimer && (
          <Typography
            $size="13px"
            $lineHeight="20px"
            $family={FontType.HelveticaRegular}
            theme={{ color: Color.Gray05 }}
            className={clsx(styles.backText, styles.disclaimer)}
          >
            {disclaimer}
          </Typography>
        )}
      </Element>
      <Element className={styles.logoContainer}>
        <Element Component="img" src={logo} alt={logoAlt} />
      </Element>
    </Element>
  );
};

export default React.memo(BackWithBottomLogo);
